import React, { createContext } from "react";
import { HashRouter as Router, HashRouter, Switch, Route, Redirect } from "react-router-dom";
import App from "./App";
import LoginPage from "./LoginPage";
import { WRAPInitializer } from "./misc/WRAPInitializer";
import Authorization from "./Authorization";
import AuthorizationObserver from "./AuthorizationObserver";
import { Loading } from "./parts/Loading";
import RemoteDateSynchronizer from "./RemoteDateSynchronizer";
import ThemeProviderComponent from './components/ThemeProviderComponent';
import WorksProfile from "./hooks/useDisplayOperation";
import { executeLinksAPI } from "./utils/LinksAPI";
import CopilotListTab from "./components/copilot/CopilotListTab";
import UserProfileSelect from "./UserProfileSelect";

function FPERouter() {
  return (
    <ProvideAuth>
      <Router hashType="noslash">
        <Switch>
          <Route exact path="/login"><LoginPage /></Route>
          <PrivateRoute exact path="/select">
            <React.Suspense fallback={<Loading/>}>
              <UserProfileSelect />
            </React.Suspense>
          </PrivateRoute>
          <PrivateRoute>
            <React.Suspense fallback={<Loading/>}>
              <RemoteDateSynchronizer>
                <Authorization>
                  <React.Suspense fallback={""}>
                    <AuthorizationObserver/>
                  </React.Suspense>
                  <Switch>
                    <Route path="/coPiList">
                      <ThemeProviderComponent>
                        <CopilotListTab />
                      </ThemeProviderComponent>
                    </Route>
                    <Route exact path="/*">
                      <HashDefault>
                        <WRAPInitializer/>
                        <WorksProfile>
                          <ThemeProviderComponent>
                            <App/>
                          </ThemeProviderComponent>
                        </WorksProfile>
                      </HashDefault>
                    </Route>
                  </Switch>
                </Authorization>
              </RemoteDateSynchronizer>
            </React.Suspense>
          </PrivateRoute>
        </Switch>
      </Router>
    </ProvideAuth>
  );
}

export default FPERouter;

function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        sessionStorage.getItem('loggedIn')? (
          children
        ) : (
          <Redirect
            to={{
            pathname: "/login",
            state: { from: location }
            }}
          />
        )
      }
    />
  );
}

function HashDefault({ children, ...rest }) {
  const pathname = window.location.pathname;
  if (Router === HashRouter) {
    if (window.location.hash === '' && window.location.href.slice(-1) === '#') {
      window.history.replaceState(null, '', pathname);
    }
  }
  return (
    children
  );
}

const cgiAuth = {
  async signIn(values) {
    let ret;
    const config = {
      method: 'post',
      data: {
        loginUser: values.id,
        password: values.password
      }
    };
    await executeLinksAPI("fosterlinks/user/login", config)
      .then(res => {
        sessionStorage.setItem('loggedIn', true);
        ret = res;
      }).catch(() => {
        ret = "";
      });
    return ret;
  },
  async signOut() {
    const config = {
      method: 'delete'
    };
    await executeLinksAPI("fosterlinks/user/logout", config)
      .then(() => {
        // console.log("logout success.");
      }).catch(() => {
        // console.log("logout failed.");
      });
    sessionStorage.removeItem('loggedIn');
  }
};

/** For more details on
 * `authContext`, `ProvideAuth`, `useAuth` and `useProvideAuth`
 * refer to: https://usehooks.com/useAuth/
 */
export const authContext = createContext();

function ProvideAuth({ children }) {
  const auth = useProvideAuth();
  return (
    <authContext.Provider value={auth}>
      {children}
    </authContext.Provider>
  );
}

function useProvideAuth() {

  const signIn = async (values) => {
    return await cgiAuth.signIn(values);
  };

  const signOut = async () => {
    return cgiAuth.signOut();
  };

  return {
    signIn,
    signOut
  };
}
